import { memo, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import cn from 'classnames';
import DeleteIcon from '@mui/icons-material/Delete';

import { ConfirmDialog } from 'components/ConfirmDialog';
import { Typography } from '../Typography/Typography';
import { useDialog } from 'hooks/useDialog';

import s from './styles.module.scss';

interface EditFooterProps {
  backButton: ReactNode | string;
  forwardButton?: ReactNode;
  showLoader: boolean;
  showDevider?: boolean;
  isEdit: boolean;
  deleteHeader?: ReactNode | string;
  deleteMain?: ReactNode | string;
  deleteFooter?: ReactNode | (() => void);
  deleteCancelText?: string;
  deleteIconLabel?: string;
  deleteWidth?: string;
}

/** @deprecated Use EditFooterV2 instead */
export const EditFooter = memo(
  ({
    backButton,
    forwardButton,
    isEdit,
    showLoader,
    showDevider = true,
    deleteHeader = '',
    deleteMain = '',
    deleteFooter,
    deleteCancelText = 'Отменить',
    deleteIconLabel = 'Удалить',
    deleteWidth,
  }: EditFooterProps) => {
    const { dialog, onOpen, onClose } = useDialog({
      open: false,
      header: deleteHeader,
      main: deleteMain,
      footer: deleteFooter,
      cancelText: deleteCancelText,
    });

    return (
      <>
        <footer className={cn(s.footer, { [s.devider]: showDevider })}>
          {isEdit && deleteFooter && (
            <button
              className={s.deleteButton}
              aria-label={deleteIconLabel}
              onClick={onOpen}
              type="button"
            >
              <DeleteIcon sx={{ fill: '#0000008F' }} />
            </button>
          )}
          {typeof backButton === 'string' ? (
            <Link
              to={backButton}
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                fontSize="0.9375rem"
                fontWeight="500"
                lineHeight="26px"
                letterSpacing="0.46px"
                color="#1976D2"
              >
                Отменить
              </Typography>
            </Link>
          ) : (
            backButton
          )}
          {forwardButton ? (
            forwardButton
          ) : (
            <LoadingButton
              type="submit"
              variant="contained"
              loading={showLoader}
              sx={{ textTransform: 'none' }}
            >
              <Typography
                color="white"
                fontSize="0.9375rem"
                fontWeight="500"
                lineHeight="26px"
                letterSpacing="0.46px"
              >
                {isEdit ? 'Сохранить изменения' : 'Создать'}
              </Typography>
            </LoadingButton>
          )}
        </footer>

        {isEdit && (deleteHeader || deleteMain) && (
          <ConfirmDialog width={deleteWidth} dialog={dialog} open={dialog.open} onClose={onClose} />
        )}
      </>
    );
  }
);
